import axiosClient from "axiosClient";
import { axiosHyperwolfDevClient } from "axiosClient";
import axiosClientHyperWolf from "axiosClient/indexHyperWolf";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO, HYPERWOLF } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function deleteCategoryAPI(cateogryId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/admin/category/${cateogryId}`);
}

export async function createCategoryAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/category`, data);
}

export async function updateCategoryAPI(data, cateogryId) {
    if(adminsMode===HYPERWOLF){
        return await axiosClientHyperWolf.put(`/api/v1/admin/category/sub/${cateogryId}`,data);
    }
    else
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/admin/category/update/${cateogryId}`, data);
}
// single category details
export async function fetchCategoryDetailsAPI(cateogryId) {
    if (adminsMode === HYPERWOLF) {
        return await axiosClientHyperWolf.get(`/api/v1/admin/category/sub/${cateogryId}?userType=admin`); // replace
    }
    else {

        return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/category/${cateogryId}?userType=admin`);
    }

}

export async function fetchWebCategoriesAPI(filters) {
    if (adminsMode === HYPERWOLF) {
        return await axiosClientHyperWolf.get(`/api/v1/admin/category?${getQueryString(filters)}`); // replace
    }
    else {
        return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/category/web?${getQueryString(filters)}`);
    }
}

// export async function fetchProductMainCategoriesAPI(filters) {
//     return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/store/products/category/listing?${getQueryString(filters)}`);
// }

export async function fetchProductMainCategoriesAPI(filters) {
    const basePath = adminsMode === STILO
        ? `/api/v1/admin/store/products/category/listing`
        : `/api/v1/admin/retailer/products/category/listing`;

    return await (adminsMode === STILO ? axiosClientStilo : axiosClient)
        .get(`${basePath}?${getQueryString(filters)}`);
}

export async function createWebCategoryAPI(data) {
    if(adminsMode=== HYPERWOLF){
        return await axiosClientHyperWolf.post(`/api/v1/admin/category/web/create-or-update`, data)
    }
    else
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/category/create/update`, data);
}

export async function deleteWebCategoryAPI(webCategoryId) {
    if(adminsMode === HYPERWOLF){
        return await axiosClientHyperWolf.delete(`api/v1/admin/category/${webCategoryId}`);
    }
    else
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/admin/category/web/${webCategoryId}`);
}
export async function fetchWebCategoryDetailsAPI(webCategoryId) {
    if (adminsMode === HYPERWOLF) {
        return await axiosClientHyperWolf.get(`/api/v1/admin/category/web/${webCategoryId}?userType=${'admin'}`)
    }
    else {
        return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/category/web/${webCategoryId}?userType=${'admin'}`);
    }
}

export async function updateWebCategoryOrdersAPI(data) {
    if (adminsMode === HYPERWOLF) {
        return await axiosClientHyperWolf.post('/api/v1/admin/category/multi', data)
    }
    else
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post('/api/v1/admin/category/update/multiple', data);
}

export async function syncBlazeCategoryAPI() {
    if (adminsMode === HYPERWOLF) {
        return await axiosClientHyperWolf.get('/api/v1/admin/category/sync/blaze/category');
    }
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get('/api/v1/admin/category/sync/blaze/category');
}